"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var styles = {
  link: {
    fontSize: 16,
    color: 'link.main',
    '&:hover': {
      textDecoration: 'none'
    }
  }
};

var RecipientExperienceFlowLink = function RecipientExperienceFlowLink(_ref) {
  var campaignId = _ref.campaignId,
      endIcon = _ref.endIcon,
      apiHost = _ref.apiHost,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? [] : _ref$sx;
  var hasApiHost = !!apiHost;
  var flowUrl = "".concat(apiHost, "/api/v1/campaigns/").concat(campaignId, "/preview");
  return hasApiHost ? /*#__PURE__*/_react.default.createElement(_material.Link, {
    sx: [styles.link].concat((0, _toConsumableArray2.default)(Array.isArray(sx) ? sx : [sx])),
    component: "a",
    href: flowUrl,
    target: "_blank",
    rel: "noreferrer"
  }, "Recipient Experience ", endIcon) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = RecipientExperienceFlowLink;
exports.default = _default;